import {
  tryParseNumber,
  tryParseNumberArray,
  tryParseArray,
  tryParseNumberAllowZero,
  tryParseString,
  tryParseNumberNullEmpty,
  transformToString,
} from 'utils/parse';

const parseOtherField = (object, field) => {
  const check = object[`${field}Check`];
  return check && check !== 'on' ? null : object[field];
};

export const serializeManip = m => ({
  ...m,
  name: tryParseString(m.name),
  manip_id: tryParseNumber(m.manip_id),
  comp_manip_id: tryParseNumber(m.comp_manip_id),
  quantity_before: tryParseNumberAllowZero(m.quantity_before),
  quantity_after: tryParseNumberAllowZero(m.quantity_after),
  consumption: tryParseNumberAllowZero(m.consumption),
  initial_quantity: transformToString(m.initial_quantity),
  captures: tryParseNumberNullEmpty(m.captures),
  captures_ref: tryParseNumber(m.captures_ref),
  species: tryParseNumberArray(m['species[]'], m.species),
  species_ref: tryParseNumber(m.species_ref),
  species_captures: tryParseArray(m['species_captures[]'], m.species_captures),
  species_other: parseOtherField(m, 'species_other'),
  species_other_capture: tryParseNumberNullEmpty(m.species_other_capture),
  comment_before: tryParseString(m.comment_before),
  comment_after: tryParseString(m.comment_after),
  product_quantity: transformToString(m.product_quantity),
  product_dilution: transformToString(m.product_dilution),
  comp_product_quantity: transformToString(m.comp_product_quantity),
  comp_product_dilution: transformToString(m.comp_product_dilution),
});

export const getConso = manip => {
  const { consumption } = manip;

  if (consumption !== undefined && consumption !== null) {
    return `${consumption} %`;
  }

  return '0 %';
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/reducers/manip.js